export default {
  goodsStatusEnum: {
    '-1': 'Pago pendiente',
    0: 'En revisión',
    1: 'Confirmación pendiente',
    2: 'Reembolso pendiente',
    3: 'Devolución de mercancías',
    4: 'Cambio de mercancías',
    5: 'Enviado por el vendedor',
    6: 'Envío separado',
    7: 'Procesamiento diferido',
    8: 'Entregado',
    9: 'En almacenamiento',
    10: 'Almacenado',
    11: 'Inválido',
    12: 'Destruido',
    13: 'Caducado',
    14: 'Confirmación de información',
    15: 'Confirmación de compra',
    16: 'Esperando proceso de devolución',
    17: 'Esperando proceso de cambio',
    18: 'Procesando devolución',
    19: 'Procesando cambio',
    20: 'Devuelto',
    21: 'Cambiado',
    22: 'Comprado',
    23: 'En proceso',
    24: 'Cancelado',
    25: 'Pedido anormal',
    26: 'Esperando reembolso',
    27: 'Esperando reenvío',
    28: 'Recogiendo',
    29: 'Empaquetado completado',
    30: 'Enviado internacionalmente',
    31: 'Recibido',
    32: 'Pedido rechazado de pago',
    33: 'Control de riesgos',
    34: 'Reembolso completado',
    35: 'Lista de pedidos congelados',
    36: 'Pago de pre-suscripción',
    37: 'Esperando recogida',
    38: 'Reembolso en proceso',
    39: 'Mercancías rechazadas',
    40: 'Rechazo completado',
    41: 'Excepción sin stock',
    42: 'Excepción con stock',
    43: 'Devolución cancelada',
    44: 'Cambio cancelado',
    45: 'Firmado y pendiente',
    46: 'Procesamiento de pedido',
    47: 'Procesamiento de pedido',
    48: 'Pago completado',
    49: 'Abandonado',
    50: 'Completado',
    51: `Devolución esperando aprobación del vendedor`,
    52: `Cambio esperando aprobación del vendedor`,
    53: 'Paquete de devolución inválido',
    54: '1688 pendiente de generación',
    55: '1688 pendiente de pago',
    58: 'Mercancías en tránsito',
    61: 'Procesamiento de pedido',
    62: 'Procesamiento de pedido',
  },
  appendStatusEnum: {
    0: 'Pendiente',
    1: 'En proceso',
    2: 'Cancelado',
    3: 'Completado',
    4: 'Devuelto',
  },
  inviteStatusEnum: {
    0: 'No activo',
    1: 'Activo',
  },
}
